/**
 * Utilidades para manejar el cache del navegador y service worker
 */

/**
 * Limpiar todo el cache del navegador
 */
export const clearAllCache = async () => {
  try {
    // Limpiar cache del Service Worker
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames.map(cacheName => caches.delete(cacheName))
      );
      console.log('✅ Cache del Service Worker limpiado');
    }
    
    // Limpiar localStorage
    localStorage.clear();
    console.log('✅ LocalStorage limpiado');
    
    // Desregistrar service worker
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(
        registrations.map(registration => registration.unregister())
      );
      console.log('✅ Service Worker desregistrado');
    }
    
    return true;
  } catch (error) {
    console.error('Error al limpiar cache:', error);
    return false;
  }
};

/**
 * Actualizar service worker
 */
export const updateServiceWorker = async () => {
  try {
    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        await registration.update();
        console.log('✅ Service Worker actualizado');
        return true;
      }
    }
    return false;
  } catch (error) {
    console.error('Error al actualizar Service Worker:', error);
    return false;
  }
};

/**
 * Verificar si hay una versión nueva del Service Worker
 */
export const checkForUpdates = async () => {
  try {
    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        await registration.update();
        return registration.waiting !== null;
      }
    }
    return false;
  } catch (error) {
    console.error('Error al verificar actualizaciones:', error);
    return false;
  }
};
